import { render, staticRenderFns } from "./GroupMigrationList.vue?vue&type=template&id=40f93118&"
import script from "./GroupMigrationList.vue?vue&type=script&lang=ts&"
export * from "./GroupMigrationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports